import React from 'react';
import styled from 'styled-components';


const ButtonComponent = styled.button`
position:relative;
display:inline-flex;
align-items:center;
justify-content:center;
text-align:center;
text-decoration:none;
vertical-align:middle;
cursor:pointer;
user-select:none;
padding:0.20rem ${(props) => props.size === 'sm' ? "0.9rem" : props.size === 'md' ? "1.1rem" : props.size === 'lg' ? "1.2rem" : "1rem"};
font-family:var(--font-poppins);
font-weight:${(props) => props.variant === 'flowless' ? '600' : '400'};
font-size:14px;
border:1px solid ${(props) => props.variant === 'primary' ? 'transparent' : props.variant === 'secondary' ? 'transparent' : props.variant === 'slate' ? 'rgb(30, 41, 59)' : 'white'};
background-color:${(props) => props.variant === 'primary' ? 'rgb(249, 115, 22)' : props.variant === 'secondary' ? 'rgb(42,68,96)' : props.variant === 'flowless' ? 'rgb(255,255,255)' : 'transparent'};
color:${(props) => props.variant === 'slate' ? 'rgb(30, 41, 59)' : props.variant === 'flowless' ? 'rgb(30, 41, 59)' : 'rgb(255,255,255)'};

transition-property: all;
transition-timing-function: liner;
transition-duration: 300ms;
`;

const Button = ({to, type, variant, className, id, onClick, children}) => {
    return(
        <ButtonComponent to={to} type={type ? type :"button"} variant={variant} className={className} id={id} onClick={onClick}>{children}</ButtonComponent>
    );
}

export default Button;
